/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_HintInputs */

const cs_ruian_hint = /** @type {(inputs: Ruian_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výběrem návrhu vyplníte známá pole. Zbytek můžete doplnit ručně.`)
};

const en_ruian_hint = /** @type {(inputs: Ruian_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a suggestion to fill known fields. You can complete the rest manually.`)
};

/**
* | output |
* | --- |
* | "Pick a suggestion to fill known fields. You can complete the rest manually." |
*
* @param {Ruian_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_hint = /** @type {((inputs?: Ruian_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_hint(inputs)
	return cs_ruian_hint(inputs)
});